import DevSphere from '../assets/projects/ds1.jpg';
import Aicpa from '../assets/projects/aicpa1.jpg';
import Wms from '../assets/projects/wms1.png';
import Delibeery from '../assets/projects/delibeery.png';
import BrandAI from '../assets/projects/brandai.png';

import HTML from '../assets/html.png';
import CSS from '../assets/css.png';
import JS from '../assets/javascript.png';
import React from '../assets/react.png';
import NodeJS from '../assets/node.png';
import Vue from '../assets/vue.png';
import Tailwind from '../assets/tailwind.png';
import Sass from '../assets/sass.png';
import Php from '../assets/php.png';
import Git from '../assets/github.png';
import Laravel from '../assets/laravel.png';
import Material from '../assets/material.png';
import Mongo from '../assets/mongo.png';
import Redux from '../assets/redux.png';
import Firebase from '../assets/firebase.png';
import Bootstrap from '../assets/bootstrap.png';
import Cap from '../assets/cap.png';
import HANA from '../assets/hana.png';
import Python from '../assets/python.png';
import D365 from '../assets/d365.png';

export const data = [
  {
    id: 1,
    name: 'Brand AI',
    image: BrandAI,
    github: '',
    live: 'https://brand-ai.net/',
    description:
      'Brand AI is a web application that enables businesses to connect with influencers worldwide across platforms like TikTok, Instagram, and YouTube through advanced search and detailed creator profiles. As a Frontend Developer, I built features including global influencer search and token management, allowing users to efficiently discover, manage, and collaborate with content creators.'
  },
  {
    id: 2,
    name: 'Dev Sphere',
    image: DevSphere,
    github: 'https://github.com/rodmc1/DevSphere',
    live: 'https://dev-sphere-rodmc1s-projects.vercel.app/',
    description:
      'DevSphere is a modern web application designed to help developers find job opportunities that match their skills and preferences. Built with Vue.js 3, Tailwind CSS, and Vite, it offers a fast and responsive user experience. The backend is powered by JSON Server, deployed on Render, serving as a lightweight REST API for job listings. The application is fully mobile-friendly and follows a serverless architecture for easy scalability'
  },
  {
    id: 3,
    name: 'AICPA & CIMA',
    image: Aicpa,
    github: '',
    live: 'https://www.aicpa-cima.com/',
    description:
      'This website is provided by the Association of International Certified Professional Accountants. As a member of their developer team, I contributed to developing the front end of the application. This project highlights my expertise in front-end development, teamwork, and delivering solutions that align with organizational goals.'
  },
  {
    id: 4,
    name: 'Warehouse Management System',
    image: Wms,
    github: '',
    live: 'https://wms.inteluck.com',
    description:
      'The Warehouse Management System (WMS) is application designed to streamline inventory tracking, order management, and warehouse operations. Built with modern web technologies, the system provides an intuitive interface for managing stock levels, processing orders, and optimizing warehouse workflows. As the sole front-end developer of this application, I developed the entire user interface using React JS.'
  },
  {
    id: 5,
    name: 'Delibeery',
    image: Delibeery,
    github: '',
    live: '',
    description:
      'My Contribution: As the sole developer of Delibeery, I was responsible for the end-to-end development of the application, including both the front-end and back-end. Delibeery demonstrates my ability to independently conceptualize, develop, and deliver a full-stack application that meets user needs and business requirements.'
  }
];

export const skillsData = [
  {
    id: 1,
    name: 'HTML',
    image: HTML,
    github: '',
    live: ''
  },
  {
    id: 2,
    name: 'CSS',
    image: CSS,
    github: '',
    live: ''
  },
  {
    id: 3,
    name: 'JavaScript',
    image: JS,
    github: '',
    live: ''
  },
  {
    id: 4,
    name: 'React',
    image: React,
    github: '',
    live: ''
  },
  {
    id: 5,
    name: 'NodeJS',
    image: NodeJS,
    github: '',
    live: ''
  },
  {
    id: 6,
    name: 'Tailwind',
    image: Tailwind,
    github: '',
    live: ''
  },
  {
    id: 7,
    name: 'Mongo',
    image: Mongo,
    github: '',
    live: ''
  },
  {
    id: 8,
    name: 'Git',
    image: Git,
    github: '',
    live: ''
  },
  {
    id: 9,
    name: 'Sass',
    image: Sass,
    github: '',
    live: ''
  },
  {
    id: 10,
    name: 'Vue',
    image: Vue,
    github: '',
    live: ''
  },
  {
    id: 11,
    name: 'Material',
    image: Material,
    github: '',
    live: ''
  },
  {
    id: 12,
    name: 'PHP',
    image: Php,
    github: '',
    live: ''
  },
  {
    id: 13,
    name: 'Redux',
    image: Redux,
    github: '',
    live: ''
  },
  {
    id: 14,
    name: 'Laravel',
    image: Laravel,
    github: '',
    live: ''
  },
  {
    id: 15,
    name: 'Bootstrap',
    image: Bootstrap,
    github: '',
    live: ''
  },
  {
    id: 16,
    name: 'Firebase',
    image: Firebase,
    github: '',
    live: ''
  },
  {
    id: 17,
    name: 'SAP CAPM',
    image: Cap,
    github: '',
    live: ''
  },
  {
    id: 18,
    name: 'SAP HANA',
    image: HANA,
    github: '',
    live: ''
  },
  {
    id: 19,
    name: 'Python',
    image: Python,
    github: '',
    live: ''
  },
  {
    id: 20,
    name: 'Microsoft D365',
    image: D365,
    github: '',
    live: ''
  }
];
